(() => {
  const init = (section) => {
    if (!section || section.dataset.npNewsletterReady === 'true') return;

    const shell = section.querySelector('[data-np-newsletter-shell]');
    const embed = section.querySelector('[data-np-newsletter-embed]');
    const loading = section.querySelector('[data-np-newsletter-loading]');
    const fallback = section.querySelector('[data-np-newsletter-fallback]');
    if (!shell || !embed) return;

    section.dataset.npNewsletterReady = 'true';
    const timeout = Number(shell.dataset.timeout) || 10000;
    let loaded = false;
    let observer;

    const showLoaded = () => {
      if (loaded) return;
      loaded = true;
      if (observer) observer.disconnect();
      if (loading) loading.hidden = true;
      if (fallback) fallback.hidden = true;
      embed.setAttribute('aria-busy', 'false');
    };

    const hasFormContent = () =>
      Boolean(embed.querySelector('form, input, button, [role="form"]')) ||
      embed.textContent.trim().length > 0;

    if (hasFormContent()) {
      showLoaded();
      return;
    }

    observer = new MutationObserver(() => {
      if (hasFormContent()) showLoaded();
    });
    observer.observe(embed, { childList: true, subtree: true });

    window.setTimeout(() => {
      if (loaded || !section.isConnected) return;
      if (loading) loading.hidden = true;
      if (fallback) fallback.hidden = false;
      embed.setAttribute('aria-busy', 'false');
    }, timeout);
  };

  const initAll = (root = document) => {
    if (root.matches?.('[data-np-newsletter]')) init(root);
    root.querySelectorAll?.('[data-np-newsletter]').forEach(init);
  };

  initAll();

  if (!window.__npNewsletterSectionListener) {
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    window.__npNewsletterSectionListener = true;
  }
})();
